import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'
import { Stack } from '@shipt/design-system-layouts'

type Props = {
  number: number
  className?: string
}

export const ActiveFiltersCircle = ({ className, number }: Props) => (
  <Circle align="center" justify="center" marginRight="xs" className={className}>
    <Body surface="inverse" size="sm" strong>
      {number}
    </Body>
  </Circle>
)

const Circle = styled(Stack)`
  border-radius: 100%;
  border: 0.0625rem solid white;
  height: 1.25rem;
  width: 1.25rem;
  background-color: ${({ theme }) => theme.color.background.base.brand.primary};
`
